import { createFileRoute } from '@tanstack/react-router'

import { FormCreatePage } from '@/pages/forms/FormCreate.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/forms/create',
)({
  component: FormCreatePage,
  loader: () => ({ breadcrumbTitle: 'Create form' }),
})
